var map = {
	"./check-in.svg": "92f9",
	"./compass-04.svg": "9ddc",
	"./gear.svg": "2ce8",
	"./lamp.svg": "3ed3",
	"./light-2.svg": "98f3",
	"./light.svg": "2da8",
	"./opening-times.svg": "33bb",
	"./pin.svg": "32d8",
	"./sun.svg": "02b4",
	"./support.svg": "4ece",
	"./temperature.svg": "a730",
	"./ventilation.svg": "1508"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4dcf";